import { UseUserQuery_user as UseUserQueryUser } from '../generated/types/UseUserQuery';
import { SetUserProps } from '../hooks/useUser';

export const NULL_USER: UseUserQueryUser = {
  __typename: 'User',
  accessToken: null,
  email: null,
  isMember: null,
  firstName: null,
  id: null,
  isLoggedIn: false,
  lastName: null,
  countryCode: '',
  isAmazonConnected: null,
  isFacebookConnected: null,
  userLoyaltyStatus: null,
  phone: null,
  statusLevel: null,
  clientTier: null
};

export const serializeUser = ({ ...user }: UseUserQueryUser | SetUserProps) => JSON.stringify(user);

export const parseUser = (cookie: string): UseUserQueryUser => {
  const user = JSON.parse(cookie);
  return {
    ...NULL_USER,
    // TODO: this is a fallback for users with old cookies without the isLoggedIn flag
    // this should be removed after a month or so (around November 2020)
    isLoggedIn: user.firstName != null,
    ...user
  };
};
